import axios from 'axios'
import { ESTransport } from 'searchkit'

export default class AxiosTransport extends ESTransport {
    host = ''

    constructor(host) {
        super()
        this.host = host
    }

    search(query) {
        return axios.post(`${this.host}/_search`, query).then(this.getData)
    }

    getData = response => response.data
}
